<template>
  <v-card width="100%" class="mx-auto">
    <v-card-title>Reset Teacher Password</v-card-title>
    <v-card-text>
      <v-text-field
        :disabled="generateTemporary"
        label="Temporary Password"
        v-model="password"
      />
      <!-- <v-text-field
        :disabled="generateTemporary"
        label="Confirm Temporary Password"
        v-model="confirmPassword"
      /> -->
      Teacher will have to reset their password after logging in the first time
      <v-checkbox
        v-model="generateTemporary"
        label="Generate temporary password"
      />

      <div v-if="tempPassword">
        <h4 style="color: orange">
          Temporary Password: {{ tempPassword }}
        </h4>
      </div>
    </v-card-text>

    <v-card-actions>
      <v-spacer />
      <v-btn :disabled="isAppLoading" class="mr-5" @click="resetPassword">Reset Password</v-btn>
      <v-checkbox label="Send Email" v-model="sendEmail" value="true" />
      <v-spacer />
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      password: "",
      confirmPassword: "",
      sendEmail: false,
      dialog: false,
      generateTemporary: true,
      tempPassword: null,
    };
  },
  computed: {
    ...mapGetters(["navState", "isAppLoading"]),
  },
  mounted() {},
  methods: {
    ...mapActions(["addSuccessMessage", "addErrorMessage"]),
    resetPassword() {

      if(this.generateTemporary){
        this.password = ''
      }

      // console.log("reset password");
      const params = {
        teacherId: this.value.id,
        sendEmail: this.sendEmail,
        tempPassword: this.password,
      };
      this.$axios
        .post("/teacher/admin/reset-password", null, { params })
        .then((resp) => {
          // console.log(resp);
          this.tempPassword = resp.data;
          if(this.sendEmail){
            this.addSuccessMessage("Password reset sent");
          }
          else{ 
            this.addSuccessMessage("Password Reset Completed")
          }
        })
        .catch(() => {
          this.addErrorMessage("Error resetting password");
        });
    },
  },
};
</script>

<style>
</style>